import React, { Component } from "react";

import BaseLayout from '../../components/BaseLayout/BaseLayout';

class Home extends Component {
	render() {
		return (
			<BaseLayout background="gray">
				<div className="home">
					<p>Page Home</p>
				</div>
			</BaseLayout>
		);
	}
}

export default Home;
